module.exports = __webpack_public_path__ + "static/img/rain.429a3ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/neutral/rain.png
// module id = S11C
// module chunks = 0